import classNames from 'classnames';
import useWorldTheme from 'hooks/shared/useWorldTheme';
import type { FC } from 'react';
import type { RadioButtonProps } from './RadioButton.types';

const themes = {
  bank: 'text-bank focus:ring-bank-200 focus:border-bank',
  expenses: 'text-expenses focus:ring-expenses-200 focus:border-expenses',
  revenues: 'text-revenues focus:ring-revenues-200 focus:border-revenues ',
  taxes: 'text-taxes focus:ring-taxes-200 focus:border-taxes',
  primary: 'text-primary focus:ring-primary-200 focus:border-primary',
};

const RadioButton: FC<RadioButtonProps> = ({
  className,
  color,
  disabled,
  onChange,
  ...props
}) => {
  const theme = useWorldTheme();

  const themeColor = themes[(color || theme) as keyof typeof themes];

  return (
    <input
      type="radio"
      className={classNames(
        'cursor-pointer h-4 w-4 transition-colors tranisiton-shadow border-primary-200 allow-focus-shadow focus:ring-offset-0',
        themeColor,
        className,
        { 'cursor-not-allowed': disabled },
        { 'hover:border-primary-400': !disabled },
      )}
      disabled={disabled}
      onChange={disabled ? undefined : onChange}
      {...props}
    />
  );
};

export default RadioButton;
